import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { fieldControlClass } from "@/components/ui/field-styles";

export type CatalogTarget = { projectId: string; isPublic: boolean };
export function validCatalogTarget(target: CatalogTarget, projects: { id: string }[], admin: boolean) {
  return target.isPublic ? admin : projects.some((p) => p.id === target.projectId);
}

export function CatalogTargetFields({ value, onChange, projects, admin, prefix }: {
  value: CatalogTarget; onChange: (value: CatalogTarget) => void;
  projects: { id: string; name: string }[]; admin: boolean; prefix: string;
}) {
  const { t } = useTranslation();
  const invalid = !validCatalogTarget(value, projects, admin);
  return <div className="flex min-w-0 flex-col gap-3">
    <Label htmlFor={`${prefix}-project`}>{t("omnimizer.wizard.catalogProject")}</Label>
    <select id={`${prefix}-project`} className={`${fieldControlClass} h-10 px-3`} disabled={value.isPublic && admin}
      value={value.projectId} aria-invalid={invalid || undefined} aria-describedby={invalid ? `${prefix}-hint` : undefined}
      onChange={(event) => onChange({ ...value, projectId: event.target.value })}>
      <option value="">{t("omnimizer.wizard.selectProject")}</option>
      {projects.map((project) => <option key={project.id} value={project.id}>{project.name}</option>)}
    </select>
    {invalid && <p id={`${prefix}-hint`} className="text-sm text-muted-foreground">{t("omnimizer.wizard.catalogProjectRequired")}</p>}
    {admin && <div className="flex items-center gap-3">
      <Switch id={`${prefix}-public`} checked={value.isPublic} onCheckedChange={(isPublic: boolean) => onChange({ ...value, isPublic })} />
      <Label htmlFor={`${prefix}-public`}>{t("omnimizer.wizard.catalogPublic")}</Label>
    </div>}
  </div>;
}
